const LOCALE = {
    // Additions and services
    TRYING_ON: "Home fitting",
    NOTIFY_ORDER_DELIVERY: "Order creation notification in CDEK",
    PART_DELIV: "Partial delivery",
    COURIER_PACKAGE_A2: "Courier package A2",
    BUBBLE_WRAP: "Bubble wrap",
    ENVELOPE_A4_CDEK_FREE: "Paper envelope",
    GET_UP: "Floor delivery",
    LOADING_OPERATIONS_AT_THE_SENDER: "Loading operations at sender",
    LOAD_THE_OPERATION_AT_THE_RECIPIENT: "Loading operations at recipient",
    BOX: "Box",
    CARTON_BOX_XS: "Box XS",
    CARTON_BOX_S: "Box S 2KG",
    CARTON_BOX_S_2_KILOS: "Box S 2KG",
    CARTON_BOX_M : "Box M",
    CARTON_BOX_L_12_KILOS: "Box L 12KG",
    CARTON_BOX_1KG: "Box 1KG",
    CARTON_BOX_2KG: "Box 2KG",
    CARTON_BOX_3KG: "Box 3KG",
    CARTON_BOX_5KG: "Box 5KG",
    CARTON_BOX_10KG : "Box 10KG",
    CARTON_BOX_20KG : "Box 20KG",
    CARTON_BOX_30KG : "Box 30KG",
    CARTON_BOXES: "Boxes",
    GET_UP_FLOOR_BY_HAND: "Carry upstairs",
    GET_UP_FLOOR_BY_ELEVATOR: "Carry upstairs by elevator",
    CARTON_BOX_XS_INFO: "Box XS (17x12x9) 0.5KG",
    CARTON_BOX_S_2_KILOS_INFO: "Box S (23x19x10) 2KG",
    CARTON_BOX_M_INFO : "Box M (33x25x15) 5KG",
    CARTON_BOX_L_12_KILOS_INFO: "Box L (31x25x38) 12KG",
    CARTON_BOX_1KG_INFO: "Box (24x17x10) 1KG",
    CARTON_BOX_2KG_INFO: "Box (34x24x10) 2KG",
    CARTON_BOX_3KG_INFO: "Box (24x24x21) 3KG",
    CARTON_BOX_5KG_INFO: "Box (40x24x21) 5KG",
    CARTON_BOX_10KG_INFO : "Box (40x35x28) 10KG",
    CARTON_BOX_20KG_INFO : "Box (47x40x43) 20KG",
    CARTON_BOX_30KG_INFO : "Box (69x39x42) 30KG",
    HEAVY_GOOD: "Heavy cargo",
    LATHING: "Crating",

    // Common fields
    address: "Address",
    tg_id: "Telegram ID",
    max_id: "Max ID",
    from_location: "From",
    to_location: "To",
    total_size: "Parcel dimensions",
    total_weight: "Parcel weight",
    calculate_weight: "Volumetric weight",
    cityFrom: "Origin city",
    cityTo: "Destination city",
    deliveryType: "Delivery type",
    deliveryMode: "Delivery mode",
    deliveryPeriod: "Delivery time",
    delivery_sum: "Delivery cost",
    calculation_parameters: "Calculation parameters",
    not_specified: "Not specified",

    fio: "Full name",
    contract_face: "Contact person",
    number: "Phone number",
    additional: "Additional number",
    pvz: "Pickup point",

    insurance: "Insurance per item",
    weight: "Item weight",
    vat: "VAT rate",
    vat_sum: "VAT amount",
    price: "Price",

    // Step 1 - Invoice Main
    main_section: "Main",
    payment_on_receipt_label: "Collect payment from recipient",
    yes: "Yes",
    no: "No",
    no_vat: "No VAT",
    sender: "Sender",
    receiver: "Recipient",
    third_party: "Third party",
    contract_number: "Contract number",
    select_contract_number: "Select contract number",
    template: "Template",
    template_name: "Template name",
    template_name_exists: "A template with this name already exists",
    no_template: "No template",
    who_are_you: "Who are you",
    city_from: "Origin city",
    city_to: "Destination city",
    search_city: "Search city",
    popular_cities: "Popular cities",

    // Step 2 - Tariff Panel
    tariff_selection: "Tariff selection",
    sort_by: "Sort by",
    price: "Price",
    period: "Transit time",
    filter: "Filter",
    no_tariffs_available: "No tariffs available",
    working_days: "business days",
    from: "from",
    to: "to",
    tariff_not_selected: "Tariff is not selected",
    error: "Error",
    error_loading_tariffs: "Failed to load tariffs",

    // Step 3 - Additions
    additional_services_cost: "Additional services cost",
    floor: "Floor",
    has_elevator: "Elevator available",
    free: "Free",
    manager_will_inform_price: "A manager will inform you of the price",
    total: "Total",

    // Step 4 - Delivery
    phones: "Phone numbers",
    field_required: "This field is required",
    name_cannot_be_only_digits: "Name cannot consist of digits only",
    pvz_selection_factors: "The following parameters may affect pickup point selection:",
    goods_weight: "Goods weight",
    volumetric_weight_used: "(volumetric weight is used)",
    receiving_city: "Receiving city",
    not_selected: "not selected",
    payment_on_receipt_yes: "Payment on receipt: yes",
    trying_on_needed_yes: "Fitting required: yes",
    no_suitable_pvz: "No suitable pickup points",
    nothing_found: "Nothing found",
    contact_person_required: "Contact person*",
    pickup_address_required: "Pickup address*",
    pvz_delivery_address_required: "Pickup point delivery address*",
    delivery_address_required: "Delivery address*",
    pickup_date_required: "Pickup date*",
    arrive_from_required: "Arrive from*",
    arrive_to_required: "Arrive until*",
    break_from: "Break from",
    break_to: "Break until",
    phone_number_required: "Phone number*",
    additional_number: "Additional number",

    // Step 5 - Calculation
    payment_from_receiver: "Payment from recipient",
    payment_from_receiver_hint: "Calculated only when payment on receipt is enabled",
    payment_by_contract: "Payment under contract",
    payment_by_contract_hint: "Payment charged under the contract",
    additional_collection_from_receiver: "Additional charge from recipient",
    additional_collection_hint: "Calculated only when payment on receipt is enabled.",
    insurance_per_unit: "Insurance per item",
    additional_charge_cod: "Additional charge from recipient (cash on delivery)",

    // Step 6 - Result Panel
    calculation_params: "Calculation parameters",
    additional_services: "Additional services",
    sender_info: "Sender",
    receiver_info: "Recipient",
    need_barcode: "Barcode required",
    total_from_client: "Total from client",
    total_by_contract: "Total under contract",
    no_additional_services: "No additional services",
    no_information: "No information",
    not_specified: "Not specified",
    door: "Door",
    warehouse: "Warehouse",
    floor_word: "floor",
    without_elevator: "without elevator",
    with_elevator: "with elevator",
    place_word: "Place",

    // Places Panel
    default_goods_name: "Consumer goods",
    personal_items: "Personal items",
    place_number: "Place #",
    calculated_weight_kg: "Calculated weight (kg):",
    height_cm: "Height, cm",
    length_cm: "Length, cm",
    width_cm: "Width, cm",
    weight_kg: "Weight, kg",
    attachment_description: "Attachment description",
    insurance_per_item: "Insurance per item, RUB",
    quantity: "Quantity",
    delete_place: "Delete place",
    goods: "Goods",
    no_name: "Untitled",
    pcs: "pcs",
    article: "Article",
    goods_name: "Product name",
    payment_per_item: "Payment per item, RUB",
    vat_sum_label: "VAT amount",
    delete_goods: "Delete product",
    add_place: "Add place",

    // Steps Header
    new_invoice: "New invoice",
    step_main_data: "Main data",
    step_tariffs: "Tariffs",
    step_additional_services: "Additional services",
    step_receiver_sender: "Recipient/Sender",
    step_calculation: "Calculation",
    step_total: "Total",

    // City Selection
    city_from_placeholder: "From",
    city_to_placeholder: "To",

    // Validation Messages
    not_all_required_fields_filled: "Not all required fields are filled in",
    insurance_sum_limit: "Insurance amount cannot exceed 399999 RUB",

    // Common
    loading: "Loading",
    save: "Save",
    cancel: "Cancel",
    create: "Create",
    update: "Update",
    delete: "Delete",
    edit: "Edit",
    back: "Back",
    next: "Next",
    close: "Close",
    select: "Select",
    search: "Search",
    apply: "Apply",
    reset: "Reset",

    // Auth
    authorization: "Authorization",
    identifier: "Identifier",
    password: "Password",
    contract_number_label: "Contract number",
    select_language: "Select language",
    language: "Language",
    russian: "Russian",
    english: "English",
    kazakh: "Kazakh",
    agree_terms: "I agree to the terms of use",
    login: "Log in",
    how_to_auth: "How do I authorize in the assistant?",
    contact_information: "Contact information",
    first_name: "First name",
    last_name: "Last name",
    middle_name: "Middle name (if any)",
    phone: "Phone",
    not_all_fields_filled: "Not all required fields are filled in",
    contract_not_found: "This contract was not found",
    contract_different_keys: "Different integration keys are used for this contract",
    integration_keys_error: "Integration keys error",

    // First Time Modal
    creating_invoice: "Create invoice",
    calculating_cost: "Calculate cost",
    creating_template: "Create template",
    editing_template: "Edit template",
    creating_claim: "Create claim",
    tracking_cargo: "Track cargo",
    auth_login: "Authorization",
    auth_contact: "Authorization",
    instruction: "Instructions",
    watch_short_instruction: "Watch a short usage guide",
    video_instruction: "Video instruction",
    not_opening_fullscreen: "Won't open in full screen?",
    open_in_new_tab: "Open in a new tab",
    close: "Close",
    browser_not_support_video: "Your browser does not support video.",
    understood: "Understood",
    skip: "Skip",
    dont_show_again: "Do not show again",

    // Delivery Types
    from_door: "from door",
    to_door: "to door",
    from_warehouse: "from warehouse",
    to_warehouse: "to warehouse",

    // Calculation Panel
    calculation: "Calculation",
    commission_from_receiver: "Commission from recipient",
    delivery_from_receiver: "Delivery from recipient",

    // Units
    pcs_short: "pcs",
    kg_short: "kg",
    art_short: "art",
    without_vat: "No VAT",

    // Templates list
    templates_list_title: "Templates",
    templates_loading: "Loading...",
    templates_error: "Failed to load templates",
    templates_empty: "No saved templates",
    notifications_title: "Notifications",
    notifications_empty: "No notifications",
    notifications_load_more: "Load more",
    notifications_loading: "Loading...",
    notifications_files: "Files",
    notifications_file_download: "Download",
    templates_create: "Create template",
    templates_delete: "Delete",
    templates_delete_confirm: "Delete template?",
    templates_delete_confirm_title: "Confirm deletion",
    templates_delete_warning: "This action cannot be undone. The template will be permanently deleted.",
    templates_delete_confirm_btn: "Delete",
    templates_delete_error: "Failed to delete template",
    templates_delete_success: "Template deleted successfully",
    templates_contract_number: "Contract number",
    templates_created_at: "Created at",
    templates_template_name: "Template name",
    templates_template_no_name: "Template #",
    templates_role: "Your role",
    who_pay_sender: "Sender",
    who_pay_reciver: "Recipient",
    who_pay_another: "Third party",
    templates_from_address: "Origin address",
    templates_to_address: "Destination address",

    // Contracts list
    contracts_list_title: "Contracts",
    contracts_loading: "Loading...",
    contracts_error: "Failed to load contracts",
    contracts_empty: "No contracts found",
    contracts_create: "Create contract",
    contracts_delete: "Delete",
    contracts_delete_confirm: "Delete contract?",
    contracts_contract_number: "Contract number",
    contracts_created_at: "Created at",
    contracts_client_company_name: "Company name",
    contracts_disable: "Disable",
    contracts_disable_confirm_title: "Confirm disable",
    contracts_disable_warning: "Contract {{contract_number}} will be disabled. This action cannot be undone.",
    contracts_disable_confirm_btn: "Disable",
    contracts_disable_success: "Contract disabled successfully",
    contracts_disable_error: "Failed to disable contract",

    // Employees
    employees_list_title: "Employees",
    employees_empty: "No employees found",
    employees_contracts_error: "Failed to load contracts",
    employees_load_error: "Failed to load employees",
    employees_delete: "Delete employee",
    employees_delete_confirm_title: "Delete employee",
    employees_delete_confirm_body: "Delete employee {{name}}? This action cannot be undone.",
    employees_delete_confirm_btn: "Delete",
    employees_delete_success: "Employee deleted successfully",
    employees_delete_error: "Failed to delete employee",
    employees_delete_no_tg_id: "Employee identifier is missing",
    employees_invite_button: "Invite employee",
    employees_invite_title: "Invite employee",
    employees_invite_get_link: "Get link",
    employees_invite_copy_link: "Copy link",
    employees_invite_link_copied: "Link copied",
    employees_invite_error: "Failed to get invite link",

    // Home & Navigation
    home_title: "Home",
    nav_home: "Home",
    nav_menu_title: "Menu",
    nav_menu_open: "Open menu",
    nav_menu_close: "Close menu",
    nav_invoice: "Create invoice",
    nav_templates: "Templates",
    nav_create_template: "Create template",
    nav_contracts: "Contracts",
    nav_add_contract: "Add contract",
    nav_employees: "Employees",
    nav_calculation: "Delivery calculation",
    nav_claim: "Claim",
    nav_tracking: "Tracking",
    nav_tracking_by_number: "Tracking by number",
    nav_tracking_from_bot: "Tracking from bot",
    nav_feedback: "Feedback",
    nav_chat: "Chat",
    nav_instructions: "Instructions",
    install_app_button: "Install app",
    install_page_title: "CDEK Assistant",
    install_page_subtitle: "Add the app to your home screen for quick access",
    install_page_feature_1: "Quick waybill creation",
    install_page_feature_2: "Package tracking",
    install_page_feature_3: "Push notifications for statuses",
    install_page_feature_4: "Works without Telegram",
    install_page_button: "Install to home screen",
    install_page_ios_title: "Installation on iPhone / iPad",
    install_page_ios_steps_title: "In Safari, add the app to your Home Screen:",
    install_page_ios_two_w1a: "Tap the icon",
    install_page_ios_two_home: "Add to Home Screen",
    install_page_ios_two_w2a: "Tap",
    install_page_ios_two_w2b: "Share",
    install_page_ios_hint: "If you don’t see Share at the bottom, use the second option.",
    install_page_success: "App installed!",
    install_page_success_subtitle: "You can now open it from your home screen",
    install_page_go_home: "Go to home",
    nav_profile: "Profile",
    nav_profile_edit: "Edit Profile",
    profile_title: "Profile",
    profile_name: "Name",
    profile_username: "Username",
    profile_contract: "Contract number",
    profile_no_contracts: "No linked contracts",
    profile_error: "Failed to load profile",
    profile_edit: "Edit",
    profile_update_title: "Edit Profile",
    profile_update_success: "Profile updated successfully",
    profile_update_error: "Failed to update profile",
    instructions_list_title: "Video instructions",
    instructions_video_invoice: "Create waybill",
    instructions_video_templates: "Templates",
    instructions_video_calculation: "Cost calculation",
    instructions_video_claims: "Claims",
    instructions_video_tracking: "Tracking",
    instructions_video_contracts: "Contracts",
    instructions_video_employees: "Employees",
    instructions_video_chat: "Chat with manager",

    share_button: "Share",
    share_copied: "Copied",
    share_failed: "Failed to copy",

    // EAEU Warning Modal
    attention: "Attention!",
    eaeu_warning_text: "Additional documents and information must be attached to the order. If you need simplified creation, return to order creation and do not change the values in the Article, Product Name, and Who Are You fields.",

    // Calculate Invoice
    calculate_invoice_title: "Invoice calculation",

    // Tracking
    tracking_parcel_title: "Parcel tracking",

    // Claim
    new_claim_title: "New claim",
    claim_word: "Claim",
    your_email: "Your email",
    contact_person_fio: "Contact person's full name",
    required_sum_rub: "Requested amount, RUB",
    describe_situation: "Describe the situation",
    attach_files: "Attach files",
    invoice_number_label: "Invoice number",
    select_invoice: "Select invoice",
    incorrect_email: "Incorrect email",
    attach_photo_video: "Attach a photo or video of the product",
    file_exceeds_size: "File exceeds 200MB",
    invalid_file_type: "Invalid file type",

    // Chat with Manager
    chat_with_manager_title: "Chat with manager",
    select_contract_for_chat: "Select a contract to enter the chat",
    enter_button: "Enter",
    chat_with_manager: "Chat with manager",

    // Package Tracking
    track_number_input: "Tracking number",
    enter_track_number: "Enter tracking number",
    invalid_contract: "Invalid contract",
    invalid_track_number: "Invalid tracking number",
    find_button: "Find",
    package_not_found: "No parcel was found for this number",
    employee_word: "Employee",

    // Track Item
    track_number_prefix: "Track No.",
    contract_word: "Contract",
    sending_progress: "Sending...",
    barcode_button: "Barcode",
    current_location: "Current location",
    planned_delivery_date: "Planned delivery date",

    // EAEU Manager Modal
    additional_information_title: "Additional information",
    eaeu_manager_modal_text: "If you need to attach documents for customs control and SNT to the invoice, and also specify the shipper, shipper address, actual seller, actual seller address, add an acceptance certificate or waybill number, specify the product name in English, marking code or Honest Sign, material, country of manufacture, or product link, please contact your manager.",

    // Instructions
    instruction_not_found: "Instruction not found",
    specify_video_url: "Please specify the video URL in the key parameter.",
    invalid_url: "Invalid URL",
    key_must_contain_url: "The key parameter must contain a valid video URL.",
    browser_not_support_video_tag: "Your browser does not support the video tag.",

    // First Time Modal Descriptions
    desc_create_invoice: "Learn how to quickly create an invoice for cargo shipping",
    desc_calculate_cost: "Learn how to calculate the delivery cost of your cargo",
    desc_create_template: "Create a template for quick invoice creation",
    desc_edit_template: "Learn how to edit an existing template",
    desc_create_claim: "Learn how to create delivery claims",
    desc_tracking: "Learn how to track your cargo status",
    desc_auth: "Learn how to authorize in the assistant",
    desc_auth_contact: "Complete the authorization process",

    // Step 4 - Delivery Panel
    fio_required: "Full name*",
    fio_or_company_required: "Full name or company name*",
    delivery_word: "Delivery",

    // Tracking Options
    select_tracking_option: "Select a tracking option",
    by_package_number: "By package number",
    invoice_created_in_assistant: "Invoice created in assistant",

    // Bot Rating
    assistant_rating_title: "Assistant rating",
    rating_label: "Rating",
    select_rating: "Select rating",
    comment_placeholder: "Comment",
    fill_required_field: "Fill in the required field",
    submit_rating: "Submit rating",
    thanks_for_review: "Thank you for your feedback!",
    ok_button: "OK",

    // Auth Contact
    contact_phone: "Contact phone",
    need_help: "Need help?",
    video_instruction_link: "Video instruction",
    accept_button: "Accept",
    fill_all_required_fields: "Please fill in all required fields.",
    data_sent_successfully: "Data sent successfully!",

    // City Search
    select_contract_for_city_search: "Select a contract to search for a city",

    // Voice Input
    voice_panel_title: "Voice field filling",
    voice_from_to: "From and to",
    voice_place_and_goods_params: "Place and product parameters",
    voice_tariffs: "Tariffs",
    voice_additional_services: "Additional services",
    voice_receiver: "Recipient",
    voice_sender: "Sender",
    voice_cargo_weight: "Cargo weight",
    voice_invoice_number: "Invoice number",
    voice_problem_description: "Problem description",
    voice_damage_amount: "Damage amount",
    voice_contact_details: "Contact details",
    voice_additional_info: "Additional information",
    voice_analyzing: "Analyzing data...",
    voice_record_hold: "Press and hold the button to record",
    voice_record_release: "Release the button to start processing",
    voice_allow_access: "Allow access",

    invoice_created: "Invoice created",
    
    // Navigation
    go_to_menu: "Go to main menu",
};

export default LOCALE;
